export const NOTIFICATION_DURATION_MS = 5500;
export const NOTIFICATION_VISIBLE_CAP = 5;

export type AppNotificationKind = "success" | "error" | "import";

export type AppNotification = {
  id: string;
  kind: AppNotificationKind;
  message: string;
  detail?: string;
  createdAt: number;
  durationMs: number | null;
  jobId?: string;
  processedRows?: number;
  totalRows?: number | null;
  createdCount?: number;
  restoredCount?: number;
  skippedCount?: number;
  failedCount?: number;
  status?: string;
};
